module.exports = __webpack_public_path__ + "img/_4.5eeb8499.png";